<div class="cu-wrapper">

  <!-- Barra de progreso mientras exporta -->
  <p-progressBar
    mode="indeterminate"
    [style]="{ height: '3px' }"
    *ngIf="uploading"
  ></p-progressBar>

  <!-- Mensajes de estado -->
  <div class="cu-status cu-status--warn" *ngIf="!hasFascicles && !uploading">
    <i class="pi pi-exclamation-triangle"></i>
    <span>{{ 'CATALOG.NO_FASCICLES' | translate }}</span>
  </div>

  <div class="cu-status cu-status--error" *ngIf="noExportCredentials">
    <i class="pi pi-lock"></i>
    <span>{{ 'CATALOG.NO_CREDENTIALS' | translate }}</span>
  </div>

  <div class="cu-status cu-status--error" *ngIf="errorUploading">
    <i class="pi pi-times-circle"></i>
    <span>{{ 'CATALOG.ERROR' | translate }}</span>
  </div>

  <div class="cu-status cu-status--success" *ngIf="uploaded">
    <i class="pi pi-check-circle"></i>
    <span>{{ 'CATALOG.SUCCESS' | translate }}</span>
  </div>

  <!-- Resumen de exportación -->
  <div class="cu-summary" *ngIf="uploaded && dataSummary">
    <h4 class="cu-summary-title">{{ 'CATALOG.EXPORT_SUMMARY' | translate }}</h4>
    <div class="cu-summary-grid">
      <span class="cu-summary-label">{{ 'CATALOG.EXPORT_SUMMARY_NAME' | translate }}</span>
      <span class="cu-summary-value">{{ dataSummary.name }}</span>

      <span class="cu-summary-label">{{ 'CATALOG.EXPORT_SUMMARY_FASCICLES' | translate }}</span>
      <span class="cu-summary-value">{{ dataSummary.totalFascicles }}</span>

      <span class="cu-summary-label">{{ 'CATALOG.EXPORT_SUMMARY_PAGES' | translate }}</span>
      <span class="cu-summary-value">{{ dataSummary.totalPages }}</span>

      <span class="cu-summary-label">{{ 'CATALOG.EXPORT_SUMMARY_CELLS' | translate }}</span>
      <span class="cu-summary-value">{{ dataSummary.totalCells }}</span>

      <span class="cu-summary-label">{{ 'CATALOG.EXPORT_SUMMARY_PRODUCTS' | translate }}</span>
      <span class="cu-summary-value">{{ dataSummary.totalProducts }}</span>
    </div>
  </div>

  <!-- Acciones -->
  <div class="cu-actions">
    <p-button
      *ngIf="!uploaded"
      icon="pi pi-file-export"
      [label]="'MENU.EXPORT_CATALOG' | translate"
      severity="primary"
      size="small"
      [disabled]="!hasFascicles || uploading"
      (onClick)="export()"
    ></p-button>
    <p-button
      *ngIf="uploaded"
      icon="pi pi-check"
      [label]="'MENU.CANCEL' | translate"
      severity="secondary"
      [outlined]="true"
      size="small"
      (onClick)="close()"
    ></p-button>
  </div>

</div>
